import { Filter, TrendingUp } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { FeedFilterType, FeedSortType } from "@/types/feedFilters";

interface FeedFilterProps {
  currentFilter: FeedFilterType;
  currentSort: FeedSortType;
  onFilterChange: (filter: FeedFilterType) => void;
  onSortChange: (sort: FeedSortType) => void;
  itemCount: number;
}

export function FeedFilter({
  currentFilter,
  currentSort,
  onFilterChange,
  onSortChange,
  itemCount,
}: FeedFilterProps) {
  const filterOptions = [
    { value: 'all', label: '🌟 All Activity' },
    { value: 'reviews', label: '📝 Reviews Only' },
    { value: 'ratings', label: '⭐ Ratings Only' },
    { value: 'milestones', label: '🏆 Milestones' },
  ];

  const sortOptions = [
    { value: 'recent', label: 'Most Recent' },
    { value: 'popular', label: 'Most Cheered' },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
      <div className="flex items-center gap-2 flex-1 sm:flex-initial">
        <Filter className="w-4 h-4 text-muted-foreground flex-shrink-0 hidden sm:block" />
        <Select value={currentFilter} onValueChange={(value) => onFilterChange(value as FeedFilterType)}>
          <SelectTrigger className="flex-1 sm:w-[160px] h-10 touch-target">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {filterOptions.map((option) => (
              <SelectItem key={option.value} value={option.value} className="touch-target">
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2 flex-1 sm:flex-initial">
        <TrendingUp className="w-4 h-4 text-muted-foreground flex-shrink-0 hidden sm:block" />
        <Select value={currentSort} onValueChange={(value) => onSortChange(value as FeedSortType)}>
          <SelectTrigger className="flex-1 sm:w-[140px] h-10 touch-target">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {sortOptions.map((option) => (
              <SelectItem key={option.value} value={option.value} className="touch-target">
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {itemCount > 0 && (
        <Badge variant="secondary" className="hidden sm:inline-flex text-xs">
          {itemCount}
        </Badge>
      )}
    </div>
  );
}
